import React, { Fragment, useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { http } from "../../helpers/http";
import Auth from "../../auth/Auth";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { updateCartLoader } from "../../redux/actions/cartActions";
import {
  clearCart,
  getCartData,
  getDisplayPrice,
  getFilteredBill,
  handleEditDish,
} from "../../helpers/help";
import CardLoader from "../widgets/CardLoader";
import { updateOnboardingState } from "../../redux/actions/authActions";
import TipSection from "./TipSection";
import { updateFullScreenLoader } from "../../redux/actions/authActions";

const ViewCart = () => {
  const additionalInfo = useRef();
  const {
    isCartItemUpdated,
    cartLoader,
    viewCartData,
    cartItems,
  } = useSelector((state) => state.cart);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const [cartQuantity, setCartQuantity] = useState(null);
  const status = pathname.includes("restaurant-details") || pathname.includes("restro-menu");
  const keysToHide = ["Donate", "Blessings Discount", "SomeKey3"];



  const updateQuantity = (key, value) => {
    if (key === "decrease" && value.dishQuantity === 0) return; //Quantity should not be zero of added cart item.
    const data = cartItems.find((item) => item.cartId === value.cartId);

    let newQuantity = value.dishQuantity;

    const apiData = {
      udId: Auth.userInfo()?.udId,
      outletId: viewCartData?.dishes?.outletDetails?.outletId,
      quantity: key === "increase" ? ++newQuantity : --newQuantity,
      cartId: data?.cartId,
      customisationId: JSON.stringify(data?.customisation),
      spl_instruction: data?.spl_instruction,
    };

    dispatch(updateCartLoader(true));
    http(
      {
        method: "POST",
        url: `updateCart`,
        isSecure: true,
        body: apiData,
      },
      (res) => {
        if (res.error === "false") {
          getCartData();
        }
      }
    );
  };

  const checkPayment = () => {
    http(
      {
        method: "POST",
        url: `checkPaymentConfig`,
        isSecure: true,
        body: {
          paymentType: 11,
          method: viewCartData?.payment_method_enable.toLowerCase(),
          outletId: viewCartData?.dishes?.outletDetails?.outletId,
          netAmount: viewCartData?.dishes?.billTotals[viewCartData?.dishes?.billTotals.length - 1]?.netAmount,
        }

      },
      (res) => {
        if (res.error === "false") {
          localStorage.setItem('payPalToken', JSON.stringify(res.payPalToken));
          const url = res.payPalToken.orderCreate.links[1].href;
          return;
        }
        if (res.error === "true") {
          toast.error(res.errorMessage);
        } else {
          status ? navigate("/checkout") : navigate(-1);
        }
        dispatch(updateFullScreenLoader(false));
      }
    )
  }


  const checkoutHandler = (value) => {
    // if (!Auth.isUserAuthenticated()) {
    //   // dispatch(updateAciModal(false));
    //   dispatch(updateOnboardingState("login"));
    //   return;
    // }
    if (viewCartData?.payment_method_enable == null) {
      toast.error("Restaurant Payment not setup at the moment. Please select another Restaurant")
      return

    } else if (viewCartData?.payment_method_enable === "Paypal") {
      status ? pathname.includes("restro-menu") ? navigate(`/restro-menu/${viewCartData?.dishes?.outletDetails?.outletId}/checkout`) : navigate("/checkout") : navigate(-1);
      checkPayment();
    }
    else {
      status ? pathname.includes("restro-menu") ? navigate(`/restro-menu/${viewCartData?.dishes?.outletDetails?.outletId}/checkout`) : navigate("/checkout") : navigate(-1);
    }
  };


  useEffect(() => {
    getCartData();
  }, [isCartItemUpdated]);

  useEffect(() => {
    if (viewCartData.dishes?.dishes) {
      additionalInfo.current &&
        (additionalInfo.current.value = localStorage.getItem("additionalInfo"));

      let count = 0;
      viewCartData.dishes.dishes.forEach((item) => {
        count = count + item.dishQuantity;
      });
      setCartQuantity(count);
    }
  }, [viewCartData]);



  return (
    <div>
      {/* <TipSection /> */}
      {viewCartData.dishes ? (
        <div className="right_box_hug">
          {cartLoader && <CardLoader />}
          <div className="white_box">
            <div className="d-flex justify-content-between">
              <h4 className="head4 bor_lineR pb-0 mb-4">YOUR CART</h4>
              {/* {status && (
                <span className="pt-1" title="Clear Cart">
                  <img
                    src="./assets/img/close-icon.svg"
                    className="pointer"
                    onClick={clearCart}
                    alt=""
                  />
                </span>
              )} */}
            </div>
            <div className="add_list_group">
              {viewCartData?.dishes?.dishes.map((dishItem) => (
                <div
                  key={`cart-id-${dishItem.cartId}`}
                  className="addlist_item mb-4"
                >
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    {/* <h5 className="head5 mb-0">{dishItem.dishName} <span className="out_stock">{dishItem.stock_status === 1 ? "(Out of Stock)" : ""}</span></h5> */}
                    <h5 className="head5 mb-0">{dishItem.dishName}</h5>
                    {dishItem.stock_status === 1 ?
                      <span className="pt-1" title="Clear Cart">
                        <img
                          src="./assets/img/close-icon.svg"
                          className="pointer"
                          onClick={clearCart}
                          alt=""
                        />
                      </span> : ""}
                    {/* <img
                      src="./assets/img/edit-icon.svg"
                      className="pointer"
                      onClick={() => handleEditDish(dishItem)}
                      alt="edit icon"
                    /> */}
                  </div>
                  {dishItem.dishCustomisation.map((dishCustomisationItem) => (
                    <Fragment
                      key={`customizableId-${dishCustomisationItem.customizableId}`}
                    >
                      {dishCustomisationItem.customizableDishItems.map(
                        (customizableDish) => (
                          <Fragment
                            key={`elementId-${customizableDish.elementId}`}
                          >

                            <div className="d-flex justify-content-between">

                              {!!customizableDish.isSelected && (
                                <p className="txt mb-1 blueCC ms-2 text-break">
                                  {customizableDish.elementName}
                                </p>
                              )}
                              {!!customizableDish.isSelected && (
                                <p className="txt mb-1 blueCC ms-2">
                                  {customizableDish.displayPrice ? customizableDish.displayPrice.charAt(0) + Number(customizableDish.displayPrice.split("$")[1]).toFixed(2) : customizableDish.displayPrice}
                                </p>
                              )}
                            </div>



                          </Fragment>
                        )
                      )}
                    </Fragment>
                  ))}
                  {dishItem.spl_instruction && (
                    <div className="  notestxtCV">
                      <span><b>Notes:</b> </span>
                      <span className="blueCC text-break"> {dishItem.spl_instruction}</span>

                    </div>
                  )}

                  {/* {dishItem.stock_status === 1 ? <span className="text-danger">Out of Stock</span> : */}
                  <div className="d-flex align-items-center justify-content-between mt-2">
                    <div className="txt align-items-center light_b d-flex">
                      <span
                        className="me-2 pointer"
                        name="minus"
                        value="minus"
                        onClick={() => updateQuantity("decrease", dishItem)}
                      >
                        <img
                          src="./assets/img/minus.svg"
                          alt="filter"
                          className="filterd-flex align-items-center"
                        />
                      </span>

                      <span className="me-2">

                        {dishItem.dishQuantity}
                      </span>

                      <span
                        className="me-2 pointer"
                        name="plus"
                        onClick={() => updateQuantity("increase", dishItem)}
                      >
                        <img
                          src="./assets/img/plus.svg"
                          alt="filter"
                          className="filter d-flex align-items-center"
                        />
                      </span>

                    </div>
                    <div className="head6">
                      {getDisplayPrice(dishItem.dishTotal)}

                    </div>
                  </div>
                  {/* } */}


                </div>
              ))}
            </div>

            {/* {!status && <TipSection />} */}
            <div className="line-content-middle my-3"></div>
            <div className="totle_amount">
              {!status && (
                <div className="input-grbox px-2 mb-2">
                  <label className="blackC">
                    <b>Additional Note</b>
                  </label>
                  <input
                    ref={additionalInfo}
                    type="text"
                    className="input_control"
                    name="details"
                    maxLength={100}
                    onChange={(event) =>
                      localStorage.setItem("additionalInfo", event.target.value)
                    }
                  />
                  <div className="line-content-middle my-3 mt-4 mb-4"></div>
                </div>

              )}




              <div
                key=""
                className="d-flex align-items-center justify-content-between mb-2"
              >
                <div className="billing-detail-key light_b">Coupon Discount:</div>
                <div className="head6">
                  <span className="coupon-amount">

                    {/* {viewCartData.couponName
                      ? `-$${viewCartData.couponSavingAmount}`
                      : "$0.00"} */}

                    {viewCartData.couponName
                      ? `$${parseFloat(viewCartData.couponSavingAmount).toFixed(2)}`
                      : "$0.00"}

                  </span>
                </div>
              </div>
              {viewCartData.dishes?.billTotals
                .filter((billCategory) => {

                  return !keysToHide.includes(billCategory.displayKey);
                })
                .map((billCategory) =>
                  getFilteredBill(billCategory.displayKey) && (
                    <div
                      key={`${billCategory.displayKey}-${billCategory.displayValue}`}
                      className="d-flex align-items-center justify-content-between mb-2"
                    >
                      <div className="billing-detail-key light_b">
                        {billCategory.displayKey}:
                      </div>
                      <div className="head6">
                        {billCategory.displayKey
                          ? billCategory.displayValue.charAt(0) +
                          Number(billCategory.displayValue.split("$")[1]).toFixed(2)
                          : billCategory.displayValue}
                      </div>
                    </div>
                  )
                )}


            </div>

            {(status && !pathname.includes('checkout')) && (
              <div className="btn_container mt-5">
                <button className="cusbtn w-100" onClick={checkoutHandler}>
                  Checkout
                  <span className="px-2 ms-2 rounded-circle text-dark bg-white text-body">
                    {cartQuantity}
                  </span>
                </button>
              </div>
            )}
          </div>
        </div>
      ) : (
        <div className="col-right right_box_hug">
          <div className="white_box">
            <h4 className="head4 bor_lineR pb-0">YOUR CART</h4>
            <div className="my-5 py-5">
              <div className="hungry-img  text-center">
                <img src="./assets/img/hungry.png" alt="" />

              </div>
              <h6 className="head6 text-center">Hungry?</h6>
              <p className="txt text-center">Add menu items to your order.</p>
            </div>


          </div>
        </div>
      )
      }
    </div >
  );
};
export default ViewCart;
